module.exports = __webpack_public_path__ + "static/img/img-xzgt.b44cbfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/pc/img-xzgt.png
// module id = QEsU
// module chunks = 0